import * as Actions from '../actions';

const initialState = {
    eventList: []
}

const studentEventReducer = function( state = initialState, action) {
    switch (action.type) {
        case (Actions.GET_STUDENT_EVENT_LIST):
            {
                return {
                    ...state,
                    eventList: action.payload
                }
            }
        default:
            {
                return state;
            }
    }
}

export default studentEventReducer;


// WEBPACK FOOTER //
// src/main/content/student/store/reducers/student_event.reducer.js